import { Link } from 'react-router-dom';
import { useClientTranslation } from '@/lib/core/i18n';

export function NotFoundError() {
  const translation = useClientTranslation();

  return (
    <div className="flex min-h-full flex-col items-center justify-center p-10">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-gray-200">404</h1>
        <h2 className="mt-4 text-3xl font-semibold text-gray-800">
          {translation('App.Labels.PageNotFound')}
        </h2>
        <p className="mt-2 text-gray-600">{translation('App.Labels.PageNotFoundDescription')}</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-lg bg-blue-600 px-6 py-3 text-white transition-colors hover:bg-blue-700"
        >
          {translation('App.Labels.GoHome')}
        </Link>
      </div>
    </div>
  );
}
